<template>
  <div class="lazyImage" :ref="lazyId"><img v-if="close" :src="imgUrl"/></div>
</template>
<script>
export default {
  props: {
    // 此处一定要用value
    imgUrl: {
      type: String,
    },
    scrollLeft: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    scrollLeft() {
      this.lazy_onload();
    },
  },
  data() {
    return {
      close: false,
      lazyId: `lazyImage${(new Date()).getTime()}${Math.ceil(Math.random() * 10000000)}`,
    };
  },
  mounted() {
    setTimeout(() => {
      this.lazy_onload();
    }, 1000);
  },
  methods: {
    lazy_onload() {
      const { offsetLeft } = this.$refs[this.lazyId];
      const scrollLeftMin = this.scrollLeft;
      const scrollLeftMax = this.scrollLeft + document.body.clientWidth;
      this.close = !!((scrollLeftMax > offsetLeft && scrollLeftMin < offsetLeft));
    },
  },
};
</script>

<style lang="less">
.lazyImage {
  width: 100%;
  height: 100%;
  > img {
    width: 100%;
    height: 100%;
  }
}
</style>
